import { IGetStateHand, IUserGetStateReturn } from "~src/user/apigen/getState";

export type LatestTurnActor = "bottom" | "left" | "right";

export type LatestTurnDisplay = {
  actor: LatestTurnActor;
  action: "play" | "pass";
};

export const getLatestTurnDisplay = (
  state: IUserGetStateReturn,
): LatestTurnDisplay | null => {
  const latestTurn = state.lastTwoTurns[0];
  if (latestTurn === undefined) {
    return null;
  }

  return {
    actor: getRelativeActor((state.turn + 2) % 3, state.position),
    action: latestTurn.length === 0 ? "pass" : "play",
  };
};

export const getHandForPosition = (
  hands: IGetStateHand[],
  position: number,
): IGetStateHand | undefined => {
  return hands.find(hand => hand.position === position);
};

const getRelativeActor = (
  actorPosition: number,
  viewerPosition: number,
): LatestTurnActor => {
  if (actorPosition === viewerPosition) {
    return "bottom";
  }

  if (actorPosition === (viewerPosition + 1) % 3) {
    return "right";
  }

  return "left";
};
